// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2UOqw","title":"Info_title__1FRCy","links":"Info_links__2lCr-","link":"Info_link__g9v4y","logo":"Info_logo__35Wut"};